import { useWeb3React } from '@web3-react/core';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { checkChainId } from '@/utils/web3Service';

import { approve, lockAiriToken } from './helpers';

const useLockWithBscChain = () => {
  const context = useWeb3React();
  const { chainId } = context;
  const provider = context.library?.provider;
  const [loading, setLoading] = useState<boolean>(false);

  const handleLockAiri = async ({
    userId,
    account,
    poolId,
    amount,
    callback,
  }: {
    userId: number;
    account: string;
    poolId: number;
    amount: string;
    callback: () => void;
  }) => {
    try {
      checkChainId(chainId);
      setLoading(true);
      const res: any = await lockAiriToken({
        provider,
        account,
        amount,
        userId,
        poolId,
        callback: (hash) => console.log(hash),
      });
      if (res?.blockHash) {
        toast.success('Locked AIRI token successfully!');
        callback();
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.log('lock_airi_token', error);
      toast.error(error?.message || 'An error occurred');
    }
  };

  const onSubmit = async ({
    userId,
    account,
    poolId,
    amount,
    allowance,
    callback,
  }: {
    userId: number;
    account: string;
    poolId: number;
    amount: string;
    allowance: string;
    callback: () => void;
  }) => {
    setLoading(true);
    const isNeedApprove = Number(allowance) < Number(amount) || allowance === '0';
    if (isNeedApprove) await handleApprove(account);
    handleLockAiri({ userId, amount, poolId, account, callback });
  };

  const handleApprove = async (account: string) => {
    try {
      checkChainId(chainId);
      await approve({
        provider,
        account,
        callback: (hash) => console.log(hash),
      });
    } catch (error: any) {
      setLoading(false);
      console.log('lock_airi_token', error);
      toast.error(error?.message || 'An error occurred');
    }
  };

  return { onSubmit, loading };
};

export default useLockWithBscChain;
